<template>
  <div class="profile-container" v-if="currentUser">
    <user-details/>
    <security-details/>
  </div>
</template>

<script>

import SecurityDetails from "./profile/SecurityDetails";
import UserDetails from "./profile/UserDetails";


export default {
  data() {
    return {
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.currentUser
    },
  },
  methods: {

  },
  components: {
    SecurityDetails,
    UserDetails,
  }
}
</script>


<style lang="scss" scoped>
  .profile-container {
    width: 100%;
    margin-top: 30px;
  }
</style>

